import {Component, Vue, Prop} from "vue-property-decorator";
import iconPlus from "~/assets/inline-svg/icon_plus.svg?inline";
import {Spinner} from "~/components/spinner";
import {Icon, icons} from "~/components/icon";

@Component
class ButtonMainCreate extends Vue {

  @Prop({ type: String, required: false, default: null }) dataTooltip: string;
  @Prop({type: Boolean, default:false}) disabled:boolean;
  @Prop({type: Boolean, default:false}) loading:boolean;

  click(){
    if(! this.disabled){
      this.$emit("click")
    }
  }

  render(){

    if (this.loading) {
      return (
        <button class={ `btn btn--main-create ${this.dataTooltip ? `has-tooltip-left`: ``}`} >
          <Spinner class="spinner--small"/>
        </button>
      );
    }

    return (
      <button class={ `btn btn--main-create ${this.dataTooltip ? `has-tooltip-left`: ``}`} disabled={this.disabled} onClick={this.click} data-tooltip={this.dataTooltip}>
         <Icon icon={icons.plus} />
      </button>
    );
  }
}

export {ButtonMainCreate};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3bee39ef/button-main-create.tsx" });